export const APP_IS_TEMPORARILY_UNAVAILABLE = false

export const LOCAL_STORAGE_NAME = '____DRIVERS_GUILD_FORM____'

export const SESSION_LIFETIME = 3600
